import React, { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import { Heading, SimpleGrid, Spacer, VStack } from "@chakra-ui/layout";

import { AuthenticatedLayout } from "layouts";
import { Invoice } from "types/invoice";
import { fetchOrgInvoices } from "api/webservice/invoice";
import InvoicesDataTable from "./InvoiceDataTable";

interface Props {
  organizationId: string;
}

const Invoices: React.FC<RouteComponentProps<Props>> = ({
  match
}: RouteComponentProps<Props>) => {
  const { organizationId } = match.params;
  const [invoices, setInvoices] = useState<Invoice[]>([]);

  const handleFetchInvoices = () => {
    fetchOrgInvoices(organizationId).then(invoices => setInvoices(invoices));
  };

  useEffect(() => {
    handleFetchInvoices();
  }, [setInvoices]);

  return (
    <AuthenticatedLayout>
      <VStack alignItems="flex-start" spacing={8}>
        <SimpleGrid columns={3} w="100%">
          <Heading size="lg">Invoice Management</Heading>
          <Spacer />
        </SimpleGrid>
        <InvoicesDataTable invoices={invoices} />
      </VStack>
    </AuthenticatedLayout>
  );
};

export default Invoices;
